/**
 * Bought Together — Frequentemente Comprados Juntos
 * Gerencia seleção de produtos sugeridos, cálculo de preço total e adição ao carrinho.
 *
 * Comportamento:
 *  - Default: nenhum selecionado → preço só do produto atual
 *  - Com seleções → soma do produto atual + produtos selecionados
 *  - Botão sempre "ADICIONAR AO CARRINHO", adiciona apenas itens selecionados
 *  - Animação fly-to-cart nos cards ao adicionar
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bought-together').forEach(initBoughtTogether);
});

function initBoughtTogether(container) {
  var suggestedCards = container.querySelectorAll('.bought-together__card:not(.bought-together__card--current)');
  var totalPriceEl = container.querySelector('[data-bt-total-price]');
  var installmentsEl = container.querySelector('[data-bt-installments]');
  var addBtn = container.querySelector('[data-bt-add-btn]');
  var addBtnText = container.querySelector('[data-bt-add-btn-text]');

  var minParcel = parseFloat(container.dataset.btMinParcel || '4000');
  var currentProductPrice = parseFloat(container.dataset.btCurrentPrice || '0');
  var currentVariantId = container.dataset.btCurrentVariant;

  // Estado: todos começam não selecionados
  var selected = new Map();
  suggestedCards.forEach(function (card) {
    selected.set(card.dataset.productId, false);
  });

  // Swiper inicializado na área de produtos (carousel apenas nos cards)
  var swiperEl = container.querySelector('.bought-together__swiper');
  var productsEl = container.querySelector('.bought-together__products');
  var swiperInstance = null;

  if (swiperEl) {
    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: {
        enabled: true,
        sticky: false,
      },
      grabCursor: true,
      watchSlidesProgress: true,
      on: {
        init: updateFadeEdges,
        slideChange: updateFadeEdges,
        progress: updateFadeEdges,
        resize: updateFadeEdges,
      },
    });
  }

  function updateFadeEdges() {
    if (!swiperInstance || !productsEl) return;
    var isBeginning = swiperInstance.isBeginning;
    var isEnd = swiperInstance.isEnd;
    var isOverflowing = !isBeginning || !isEnd;

    productsEl.classList.toggle('bought-together__products--fade-left', !isBeginning);
    productsEl.classList.toggle('bought-together__products--fade-right', !isEnd && isOverflowing);
  }

  // Clique nas cards sugeridas para alternar seleção
  suggestedCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var id = card.dataset.productId;
      var nowSelected = !selected.get(id);
      selected.set(id, nowSelected);
      updateCardUI(card, nowSelected);
      updateSummary();
    });
  });

  // Botão: adicionar ao carrinho os itens selecionados
  addBtn.addEventListener('click', function () {
    addToCart();
  });

  // Seta clicável: avança o carrossel
  var scrollNextBtn = container.querySelector('[data-bt-scroll-next]');
  if (scrollNextBtn) {
    scrollNextBtn.addEventListener('click', function () {
      if (!swiperInstance) return;
      var slideWidth = swiperInstance.slides[0] ? swiperInstance.slides[0].offsetWidth : 150;
      var currentTranslate = swiperInstance.getTranslate();
      swiperInstance.setTranslate(currentTranslate - slideWidth);
      swiperInstance.setTransition(300);
      requestAnimationFrame(function () {
        swiperInstance.translateTo(currentTranslate - slideWidth, 300);
      });
    });
  }

  updateSummary();

  // ── Helpers ──

  function updateCardUI(card, isSelected) {
    var badge = card.querySelector('.bought-together__badge');
    card.classList.toggle('bought-together__card--unselected', !isSelected);
    if (badge) {
      badge.className = 'bought-together__badge ' +
        (isSelected ? 'bought-together__badge--selected' : 'bought-together__badge--select');
      badge.textContent = isSelected ? 'SELECIONADO' : 'SELECIONAR';
    }
  }

  function updateSummary() {
    var total = currentProductPrice;

    suggestedCards.forEach(function (card) {
      if (selected.get(card.dataset.productId)) {
        total += parseFloat(card.dataset.productPrice || '0');
      }
    });

    totalPriceEl.textContent = formatMoney(total);

    if (installmentsEl) {
      var maxParcelas = Math.floor(total / minParcel);
      if (maxParcelas < 1) maxParcelas = 1;
      if (maxParcelas > 12) maxParcelas = 12;
      var parcelaValue = total / maxParcelas;
      installmentsEl.textContent = 'em até ' + maxParcelas + 'x de ' + formatMoney(parcelaValue);
    }

    addBtnText.textContent = 'ADICIONAR AO CARRINHO';
  }

  function animateFlyToCart(card) {
    var cartIcon = document.querySelector('.header-actions__cart-icon');
    var img = card.querySelector('.bought-together__card-image img');
    if (!cartIcon || !img) return;

    var flyEl = document.createElement('fly-to-cart');
    flyEl.classList.add('fly-to-cart--quick');
    flyEl.style.setProperty('background-image', 'url(' + img.src + ')');
    flyEl.style.setProperty('--start-opacity', '0');
    flyEl.source = card;
    flyEl.useSourceSize = false;
    flyEl.destination = cartIcon;
    document.body.appendChild(flyEl);
  }

  function addToCart() {
    var items = [];
    var cardsToAnimate = [];

    // Sempre inclui o produto atual
    var currentCard = container.querySelector('.bought-together__card--current');
    if (currentVariantId) {
      items.push({ id: parseInt(currentVariantId), quantity: 1 });
      if (currentCard) cardsToAnimate.push(currentCard);
    }

    // Inclui apenas os selecionados
    suggestedCards.forEach(function (card) {
      if (selected.get(card.dataset.productId)) {
        var variantId = card.dataset.variantId;
        if (variantId) {
          items.push({ id: parseInt(variantId), quantity: 1 });
          cardsToAnimate.push(card);
        }
      }
    });

    if (items.length === 0) return;

    addBtn.disabled = true;
    addBtnText.textContent = 'ADICIONANDO...';

    // Animação fly-to-cart para cada card
    cardsToAnimate.forEach(function (card, i) {
      setTimeout(function () {
        animateFlyToCart(card);
      }, i * 100);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Erro');
        return res.json();
      })
      .then(function (response) {
        addBtnText.textContent = 'ADICIONADO!';

        // Dispara cart:update para atualizar o carrinho e abrir o drawer (mesmo padrão do product-form)
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            sourceId: 'bought-together',
            data: {
              source: 'bought-together',
              itemCount: items.length,
              sections: response.sections || {},
            },
          },
        }));

        setTimeout(function () {
          addBtn.disabled = false;
          updateSummary();
        }, 1500);
      })
      .catch(function () {
        addBtnText.textContent = 'ERRO - TENTE NOVAMENTE';
        addBtn.disabled = false;
        setTimeout(updateSummary, 2000);
      });
  }

  function formatMoney(cents) {
    var value = cents / 100;
    return 'R$' + value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}
